import classNames from "classnames"
import { ddlListItem } from "../../components/dropDownList/DropDownList"
import { IFormDataInput } from "../../model/IFormDataInput"
import { getDatePickerPattern, getEmailPattern, getPhoneNumPattern, getPostalCodePattern, getSpecialCharacterPattern } from "../../utils/patternHelper"
import { IChildPlanFormData } from "../ChildPlanFormDataContext"
import { IParentFormData } from "../ParentFormDataContext"

export const ResponsiveWidth = 'lg:w-[20rem] md:w-[17rem] w-[14rem]'

export const ParentFormDataInputObject: IFormDataInput[] = [
    {
        Id: 'ProvList',
        Name: 'Province',
        Type: '',
        ControlType: 'DropDownList',
        ListItems: [{ id: '', name: '' }],
        Placeholder: 'Province.',
        Label: 'province',
        Required: true,
        ClassName: 'mx-1.5 mr-2 lg:ml-[0.5rem] md:ml-[0.5rem] ml-[0.5rem]',
        Width: ResponsiveWidth,
        Height: 'h-10',
        Shadow: '',
        ErrorMessageList: [{ type: 'required', error: 'required' }],
        ErrorMessage: '',
        Pattern: '',
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
    {
        Id: 'AddressInput',
        Name: 'Address',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'Address',
        Label: 'address',
        Required: true,
        ClassName: '',
        Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400 "),
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [
            { type: 'required', error: 'required' },
            { type: 'pattern', error: 'specialcharpatternerror' },
        ],
        ErrorMessage: '',
        Pattern: getSpecialCharacterPattern(),
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
    {
        Id: 'CityInput',
        Name: 'City',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'City',
        Label: 'city',
        Required: true,
        ClassName: '',
        Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400 "),
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [
            { type: 'required', error: 'required' },
            { type: 'pattern', error: 'specialcharpatternerror' },
        ],
        ErrorMessage: '',
        Pattern: getSpecialCharacterPattern(),
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
    {
        Id: 'PostalCodeInput',
        Name: 'PostalCode',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'Postal Code',
        Label: 'postalCode',
        Required: true,
        ClassName: '',
        Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400 "),
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [
            { type: 'required', error: 'required' },
            { type: 'pattern', error: 'postalcodepatternerror' },
        ],
        ErrorMessage: '',
        Pattern: getPostalCodePattern(),
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
    {
        Id: 'FnInput',
        Name: 'FirstName',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'First Name.',
        Label: 'firstName',
        Required: true,
        ClassName: '',
        Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400 "),
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [
            { type: 'required', error: 'required' },
            { type: 'pattern', error: 'specialcharpatternerror' },
        ],
        ErrorMessage: '',
        Pattern: getSpecialCharacterPattern(),
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
    {
        Id: 'LnInput',
        Name: 'LastName',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'Last Name.',
        Label: 'lastName',
        Required: true,
        ClassName: '',
        Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400 "),
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [
            { type: 'required', error: 'required' },
            { type: 'pattern', error: 'specialcharpatternerror' },
        ],
        ErrorMessage: '',
        Pattern: getSpecialCharacterPattern(),
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
    {
        Id: 'PhoneNumInput',
        Name: 'PhoneNumber',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'Phone Number',
        Label: 'phoneNum',
        Required: true,
        ClassName: '',
        Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400 "),
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [
            { type: 'required', error: 'required' },
            { type: 'pattern', error: 'phonenumpatternerror' },
        ],
        ErrorMessage: '',
        Pattern: getPhoneNumPattern(),
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    },
    {
        Id: 'EmailInput',
        Name: 'Email',
        Type: 'text',
        ControlType: 'InputBox',
        Placeholder: 'Email Address',
        Label: 'emailAddress',
        Required: true,
        ClassName: '',
        Width: classNames(ResponsiveWidth, "border-[1.5px] border-gray-400 "),
        Height: 'h-10',
        Shadow: 'shadow-md',
        ErrorMessageList: [
            { type: 'required', error: 'required' },
            { type: 'pattern', error: 'emailpatternerror' },
        ],
        ErrorMessage: '',
        Pattern: getEmailPattern(),
        IsValid: false,
        IsBlur: false,
        IsFocus: false,
        Disabled: false,
    }
]

export const CommonChildPlanFormInputDataObject = {
    Id: 'SchoolBoardDDL',
    Name: 'SchoolBoard',
    Type: '',
    ControlType: 'DropDownList',
    ListItems: [{ id: '', name: '' } as ddlListItem],
    Placeholder: '',
    Label: 'schoolBoard',
    Required: true,
    ClassName: 'z-10 lg:px-0',
    Width: classNames(ResponsiveWidth),
    Height: 'h-10',
    Shadow: '',
    ErrorMessageList: [{ type: 'required', error: 'required' }],
    ErrorMessage: '',
    Pattern: '',
    IsValid: false,
    IsBlur: false,
    IsFocus: false,
    Disabled: false,
}

export const CommonChildPlanStartDateObject = {
    Id: 'PolicyStartDate',
    Name: 'PolicyStartDate',
    ControlType: 'DatePicker',
    Placeholder: 'dateformat',
    Label: 'policyStartDate',
    Width: "lg:w-[20rem] md:w-[17rem] w-[14rem] min-w-[14rem] border-[1.5px] border-gray-400",
    Height: 'min-h-[40px]',
    Shadow: 'shadow-md',
    Required: true,
    ClassName: '',
    ErrorMessageList: [{ type: 'required', error: 'Required' }],
    ErrorMessage: 'required',
    Pattern: getDatePickerPattern(),
    IsValid: true,
    IsBlur: false,
    IsFocus: false,
}

export const getToday = () => {
    const today = new Date();
    // const tomorrow = new Date(today.getTime() + 86400000)
    return today
}

export const ParentDataObject: IParentFormData = {
    ReturnHome: '',
    Province: { id: '', name: '' },
    Language: 0,
    FirstName: '',
    LastName: '',
    Address: '',
    City: '',
    PostalCode: '',
    PhoneNumber: '',
    Email: '',
    ExternalRef: '',
    DoNotOffer: false,
    OrgGuid: '',
    RegionId: 0,
    ParentFormDataInput: ParentFormDataInputObject,
    StartDate: getToday(),
    QuoteErrorMessages: [],
    TotalPremium: 0,
    FamilyRate: false,
    SchoolBoard: { id: '', name: '' },
    PlanDuration: {
        DurationText: '',
        Duration: 1,
        Discount: '',
        Index: 0,
    },
    AutoEnroll: {
        Renew: '',
        Index: -1,
        IsValid: false,
    },
    CommonChildPlanFormInputData: CommonChildPlanFormInputDataObject,
    CommonChildPlanStartDate: CommonChildPlanStartDateObject,
    SchoolListItems: [{ id: '', name: '' }]
}

export const disableProvinceDDL = (parentFormData: IParentFormData, setParentFormData: React.Dispatch<React.SetStateAction<IParentFormData>>) => {
    const dataInput = parentFormData.ParentFormDataInput.find(
        (x) => x.Name === 'Province'
    )

    if (dataInput) {
        const updatedTemp = {
            ...dataInput,
            Disabled: true,
        }
        const updatedFormInputs = [...parentFormData.ParentFormDataInput]
        const index = updatedFormInputs.indexOf(dataInput)
        updatedFormInputs[index] = updatedTemp
        setParentFormData((prevState) => ({
            ...prevState,
            ParentFormDataInput: updatedFormInputs,
        }))
    }
}

export const disableSchoolBoardDDL = (setParentFormData: React.Dispatch<React.SetStateAction<IParentFormData>>) => {
    setParentFormData((prevFormData) => {
        const newFormData = {
            ...prevFormData,
            CommonChildPlanFormInputData: {
                ...prevFormData.CommonChildPlanFormInputData,
                Disabled: true,
            },
        };
        return newFormData;
    });
}

export const disableSchoolDDL = (childPlanFormData: IChildPlanFormData[], setChildPlanFormData: React.Dispatch<React.SetStateAction<IChildPlanFormData[]>>) => {
    childPlanFormData.map((child, i) => {
        const dataInput = child.ChildPlanFormDataInput.find(
            (x) => x.Name === 'School'
        )
        if (dataInput != null) {
            const updated = {
                ...dataInput,
                Disabled: true,
            }
            const updatedFormInputs = [...child.ChildPlanFormDataInput]
            const index = updatedFormInputs.indexOf(dataInput)
            updatedFormInputs[index] = updated

            setChildPlanFormData((prevFormData) => {
                const newFormData = [...prevFormData]
                newFormData[i] = {
                    ...child,
                    ChildPlanFormDataInput: updatedFormInputs,
                }
                return newFormData
            })
        }
    })

}